<template>
  <div>
    <!-- MOBILE OVERLAY -->
    <div v-if="isOpen" class="fixed inset-0 bg-black/40 z-40 lg:hidden" @click="closeMenu"></div>

    <!-- SIDEBAR -->
    <aside class="bg-white border-r border-slate-200 flex flex-col shrink-0
             fixed lg:static top-0 left-0 h-full z-50
             transition-transform duration-300 ease-in-out" :class="[
        isOpen ? 'translate-x-0' : '-translate-x-full',
        'w-64 lg:translate-x-0'
      ]">
      <!-- Logo -->
      <div class="p-6 flex items-center gap-3">
         <img src="/images/logo1.png" style="height: 3rem;">
      </div>

      <!-- Navigation -->
      <nav class="flex-1 px-4 space-y-1 overflow-y-auto">
        <a v-for="menu in menus" :key="menu.name" @click="setActive(menu.name,menu.goto)"
          class="flex items-center gap-3 px-3 py-2 rounded-lg cursor-pointer transition-colors" :class="activeMenu === menu.goto
            ? 'bg-primary/10 text-primary font-medium'
            : 'text-slate-600 hover:bg-slate-50'">
          <span class="material-symbols-outlined">{{ menu.icon }}</span>
          <span>{{ menu.name }}</span>
        </a>
      </nav>

      <!-- Plan -->
      <div class="p-4 border-t border-slate-100" v-if="ldata!=null && ldata.user_type!=='admin'">
        <div class="bg-slate-50 rounded-xl p-4">
          <p class="text-xs font-semibold text-slate-500 uppercase mb-2">Current Plan</p>
          <p class="text-sm font-bold text-slate-800" v-if="planDt==null">Free Plan</p>
          <p class="text-sm font-bold text-slate-800" v-if="planDt!=null">{{ planDt.user_plan_name }}</p>
          <p class="text-sm font-bold text-slate-400" v-if="planDt!=null">Renews on {{ getExpDate(planDt.user_plan_pur_date,planDt.user_plan_duration) }}</p>

          <!-- ✅ Buttons Row -->
          <div class="mt-3 flex gap-2">

            <button @click="gotobill()"
              class="flex-1 bg-white border border-slate-200 text-xs font-bold py-2 rounded-lg">
              Manage Billing
            </button>

           <span
              @click="showLogoutDialog = true"
              class="material-symbols-outlined cursor-pointer text-white hover:text-white
                    bg-primary border border-slate-200 rounded-lg p-2 transition-colors">
              logout
            </span>

          </div>
        </div>
      </div>
    </aside>
    <!-- ✅ LOGOUT CONFIRM DIALOG -->
    <div v-if="showLogoutDialog" class="fixed inset-0 bg-black/40 z-[100] flex items-center justify-center">

      <div class="bg-white rounded-2xl shadow-xl w-[340px] p-6">

        <h3 class="text-lg font-bold text-slate-800 mb-2">
          Confirm Logout
        </h3>

        <p class="text-sm text-slate-500 mb-6">
          Are you sure you want to logout from your session?
        </p>

        <div class="flex justify-end gap-3">

          <button
            @click="showLogoutDialog = false"
            class="px-4 py-2 text-sm font-bold text-slate-600 hover:bg-slate-50 rounded-lg">
            Cancel
          </button>

          <button
            @click="confirmLogout()"
            class="px-4 py-2 text-sm font-bold bg-primary text-white rounded-lg hover:bg-primary-700">
            Logout
          </button>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import { getUdt } from "@/apis/userapis";
  export default {
    props: ['isOpen'],

    data() {
      return {
        showLogoutDialog: false,   
        activeMenu: '/',
        ldata: null,
        planDt: null,
        menus: [
          { name: 'Dashboard', icon: 'dashboard', goto: "/" },
          { name: 'Reviews', icon: 'rate_review', goto: "/review-list" },
          { name: 'Review Campaigns', icon: 'campaign', goto: "/camplain-list" },
          { name: 'Referral Campaigns', icon: 'share_reviews', goto: "/reffrals" },
          { name: 'Customers', icon: 'group', goto: "/customer-list" },
          { name: 'QR Codes', icon: 'qr_code_2', goto: "/qr-code" },
          // { name: 'Analytics', icon: 'bar_chart', goto: "/analytics" },
          { name: 'Settings', icon: 'settings', goto: "/settings?typ=business" }
        ]
      }
    },
    mounted() {
      const tmp = sessionStorage.getItem("ldata") || "";
      if (tmp && tmp.length > 0) {
        this.ldata = JSON.parse(tmp);
        this.getUdtNow();
        if (this.ldata.user_type === "admin") {
          this.menus = [
            { name: 'Dashboard', icon: 'space_dashboard', goto: '/home1' },
            { name: 'Businesses', icon: 'business', goto: '/admin/businesses' },
            { name: 'Subscriptions', icon: 'credit_card', goto: '/admin/subscriptions' },
            { name: 'Users', icon: 'payments', goto: '/admin/users' },
            { name: 'Settings', icon: 'settings', goto: '/admin/settings' },
            { name: 'Logout', icon: 'logout', goto: "/logout" }
          ];
        }
      }
      this.activeMenu = "/" + window.location.pathname.split("/").filter(seg => seg !== "") + "";
    },

    methods: {
      getExpDate(purchase_date, duration_days) {

        if (!purchase_date || !duration_days) return "";

        const date = new Date(purchase_date);

        date.setDate(date.getDate() + parseInt(duration_days));

        return date.toISOString().split("T")[0];
      },
      async getUdtNow() {

        try {

          const res = await getUdt(
            this.ldata.user_id,
          );

          if (!res.status) {
            return;
          }

          // ✅ UPDATE SESSION DATA
          this.planDt = res.planDt;

          
        } catch (error) {
          console.error(error);
        }
      },
      setActive(menu, destination) {
        if(menu==="Logout"){
          this.logout();
        }
        else{
          this.activeMenu = menu
          this.closeMenu()
          window.location.href = destination + "";
        }
      },
      logout() {
        this.showLogoutDialog = true;
      },

      confirmLogout() {
        sessionStorage.removeItem("ldata");
        window.location.href = "/login";
      },
      gotobill() {
        window.location.href = "/settings?typ=billing";
      },

      closeMenu() {
        this.$emit('close')
      }
    }
  }
</script>